import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconMediumComponent } from "./med-icon-medium.component";

@NgModule({
  declarations: [
    MedIconMediumComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconMediumComponent,
  ],
})
export class MedIconMediumModule { }
